import React from 'react';

const WithDeviceDetailsHOC = (WrappedComponent: any) => {
  return (props: any) => {
    const width = window.innerWidth;
    const deviceType =
      width < 768 ? 'mobile' : width >= 768 && width < 1024 ? 'tab' : 'desktop';
    return <WrappedComponent {...props} deviceType={deviceType} />;
  };
};

export default WithDeviceDetailsHOC;
